// src/components/Issues.js

import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axios';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import "./issues.css"

const Issues = () => {
  const [issues, setIssues] = useState([]);

  useEffect(() => {
    axiosInstance.get('issues/')
      .then(response => {

        setIssues(response.data);
      })
      .catch(error => {
        console.error('Error fetching issues:', error);
      });
  }, []);

  const columns = [
    { headerName: "ID", field: "id" },
    { headerName: "Path", field: "path" },
    {
      headerName: "Issue URL",
      field: "issue_ext_reference_id",
      cellRenderer: (params) => {
        const id = params.value;
        // url.searchParams.append('issue_extid', params.data.issue_extid);
        return <a href={`/issueDetails/${id}`} target="_blank" rel="noopener noreferrer">View Issue</a>;
      }
    },
    { headerName: "Status", field: "status" },
    { headerName: "Assay Type", field: "config_type" },
    { headerName: "Assay Provider Contact", field: "cro_contact" },
    { headerName: "Data File Assay Provider", field: "data_file_cro" },
    { headerName: "Data File Program", field: "data_file_program" },
    { headerName: "Labels", field: "labels" },
    { headerName: "Last Updated", field: "last_updated" },
    { headerName: "Creation Date", field: "creation_date" },
  ];

  return (
    <div className="ag-theme-alpine" style={{ height: 350, marginBottom:40, width: '100%' }}>
      <div style={{ fontSize:"20px",margin:"10px" }}>Recent Activity</div>
      <AgGridReact
        rowData={issues}
        columnDefs={columns}
      />
    </div>
  );
};

export default Issues;
